var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"front-card",style:(_vm.customStyles)},[_c('div',{staticClass:"ribbon"},[_c('p',{staticClass:"ribbon-text",class:((_vm.item.titleNameSize.value) + "-text")},[_vm._v(_vm._s(_vm.item.name))])])])}
var staticRenderFns = []

export { render, staticRenderFns }